import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import Fab from "@mui/material/Fab";
import { useThemeContext } from "../contexts/theme/useThemeContext";
import { ThemeProvider } from "@mui/material";

type Props = {
  disabled?: boolean;
  size?: "small" | "medium" | "large";
};

export const ThemeSwitchButton = (props: Props) => {
  const { mode, setMode, muiThemes } = useThemeContext();

  const nextThemeMode = mode === "light" ? "dark" : "light";
  const theme = muiThemes[nextThemeMode];

  return (
    <>
      <ThemeProvider theme={theme}>
        <Fab
          disabled={props.disabled}
          size={props.size}
          sx={() => ({
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor:
                mode === "light"
                  ? theme.lighten(theme.palette.background.default, 0.2)
                  : theme.darken(theme.palette.background.default, 0.2),
            },
          })}
          onClick={() => {
            setMode(nextThemeMode);
          }}
        >
          {mode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
        </Fab>
      </ThemeProvider>
    </>
  );
};
